import React from 'react';
import {FormattedMessage} from 'react-intl';
import {toAbsoluteUrl} from '../../../../../_metronic/_helpers';
import styles from './styles.module.scss';

export const Footer = ({count, totalAmount = 0}) => {

  return (
    <div className={styles.footerContainer}>
      <div className={styles.footer}>
        <div className={styles.content}>
          <img
            src={toAbsoluteUrl('media/svg/Info-circle_brandColor.svg')}
            alt="info"
          />
          {Boolean(count) && (
            <FormattedMessage
              id='users-page-footer-total'
              defaultMessage='Number of Records Found - {count}'
              values={{count: count
                  ? count.toLocaleString('en-US', {minimumFractionDigits: 0, maximumFractionDigits: 0})
                  : 0
            }}
            />
          )}
        </div>
        <div className={styles.content}>
          {Boolean(totalAmount) && (
            <FormattedMessage
              id='page-footer-totalAmount'
              defaultMessage='Total amount - {totalAmount}'
              values={{totalAmount}}
            />
          )}
        </div>
      </div>
    </div>
  );
};
